module.exports = __webpack_public_path__ + "img/bg-balls.be69399.png";